import React, { FunctionComponent, useContext } from "react";

import { AuthContext } from "./AuthProvider";
import { User } from "./User";

export const UserContext = React.createContext<User>({
    name: "",
    email: "",
    roles: [],
    accessToken: "",
    idToken: "",
    accessRights: [],
    originatorIds: []
});

type UserProviderProps = React.PropsWithChildren<unknown>;

export const UserProvider: FunctionComponent<UserProviderProps> = (props: UserProviderProps) => {
    const { children } = props;

    const authContext = useContext(AuthContext);

    return <UserContext.Provider value={authContext.sprintUser}>{children}</UserContext.Provider>;
};
